export default __webpack_public_path__ + "assets/images/button-phone.39ae4544787e1d0dc77cbce8805381e4.svg";